import { defineNuxtPlugin, useRuntimeConfig } from '#imports'

import { isTestEnv } from '@backmarket/utils/env/isTestEnv'

import { useI18n } from './composables/useI18n'
import { useInjectTranslationsScriptInHead } from './composables/useInjectTranslationsScriptInHead'
import { NUXT_STATE_KEY, PROCESS_KEY } from './constants'
import type { I18n } from './types'
import { getRequestLocale } from './utils/getRequestLocale'

export type Injections = {
  i18n: I18n
}

export default defineNuxtPlugin<Injections>({
  name: 'i18n',
  setup: (nuxt) => {
    if (nuxt.ssrContext) {
      const locale = getRequestLocale(nuxt.ssrContext.event)

      if (!globalThis[PROCESS_KEY]) {
        throw new Error(
          '[nuxt-module-i18n] Cannot retrieve translations from the main process',
        )
      }

      // eslint-disable-next-line no-param-reassign
      nuxt.payload.state[NUXT_STATE_KEY] = {
        locale,
      }

      useInjectTranslationsScriptInHead(locale)
    }

    const { i18n } = useRuntimeConfig().public

    if (
      !isTestEnv() &&
      !nuxt.payload.state[NUXT_STATE_KEY]?.locale &&
      !i18n.fallbackLocale
    ) {
      throw new Error('[nuxt-module-i18n] Cannot retrieve locale in useState')
    }

    return {
      provide: {
        i18n: useI18n(),
      },
    }
  },
})
